module.exports = __webpack_public_path__ + "img/03.7401a845.png";